import { COURIER_RELEASE_ATTRIBUTIONS, COURIER_RELEASE_NOTE_MAX_LENGTH, COURIER_RELEASE_REASONS, SEND_AFTER_PICKUP_CAUSE_CODES, afterPickupCauseOf, isCourierReleaseAttribution, isCourierReleaseReason, } from '@vello/delivery-dispatch';
/**
 * D856 (R2) + D858: why a Send ended after its pickup - decides who pays (`send.afterPickupPolicy`). The release vocabulary and its cause mapping are the DOMAIN's own
 * (`@vello/delivery-dispatch`): the client re-exports them, so the dialog's preview and the server's decision can never disagree (D858 retired the hand-kept copy).
 */
export { COURIER_RELEASE_ATTRIBUTIONS, COURIER_RELEASE_NOTE_MAX_LENGTH, COURIER_RELEASE_REASONS, SEND_AFTER_PICKUP_CAUSE_CODES };
/**
 * D856 (R2) + D858: the cause an operator's release reason names (the server's own `afterPickupCauseOf`; the server decides - this only words the preview). `undefined` while the
 * cause cannot be told yet: no reason, an unknown one, or a `PIN_LOCKED` release whose attribution (`RECIPIENT` / `COURIER`) is not chosen.
 */
export function afterPickupCauseOfReason(reason, attribution) {
    if (!isCourierReleaseReason(reason))
        return undefined;
    return afterPickupCauseOf(reason, isCourierReleaseAttribution(attribution) ? attribution : undefined);
}
export class CourierDispatchAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** A market's courier jobs, newest first (at most 100), with the stuck-courier signals and the release history. */
    jobs(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/courier-dispatch/jobs?marketId=${encodeURIComponent(marketId)}`, auth: true });
    }
    /** Release the job's courier (the operator is the session). */
    release(jobId, input) {
        return this.client.request({ method: 'POST', path: `/v1/courier-dispatch/jobs/${encodeURIComponent(jobId)}/release`, body: input, auth: true });
    }
}
//# sourceMappingURL=courier-dispatch-admin.js.map